import { render, staticRenderFns } from "./healthyList.vue?vue&type=template&id=52aaa1bf&scoped=true"
import script from "./healthyList.vue?vue&type=script&lang=js"
export * from "./healthyList.vue?vue&type=script&lang=js"
import style0 from "./healthyList.vue?vue&type=style&index=0&id=52aaa1bf&prod&lang=scss&scoped=true"
import style1 from "./healthyList.vue?vue&type=style&index=1&id=52aaa1bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aaa1bf",
  null
  
)

export default component.exports